/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/search-otg': {
    width: 24,
    height: 26,
    viewBox: '0 0 24 26',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M4.112 15.494c-2.817-2.859-2.814-7.51.006-10.366a7.082 7.082 0 015.07-2.13 7.08 7.08 0 015.077 2.137c2.817 2.86 2.814 7.511-.008 10.368a7.08 7.08 0 01-5.069 2.13c-1.916 0-3.72-.76-5.077-2.139zM24 23.536l-7.79-7.222c3.046-3.658 2.878-9.133-.52-12.583a9.097 9.097 0 00-12.996-.009c-3.59 3.635-3.594 9.537-.008 13.176a9.096 9.096 0 006.501 2.735 9.082 9.082 0 005.582-1.927l7.87 7.297L24 23.536z" _fill="#37A48B"/>'
  }
})
